import TopBar from './components/TopBar';
import './App.css';
import PageRenderer from './components/PageRenderer';
import { usePage } from './content/PageContext';

export default function PublicSite() {
  const { page, loaded } = usePage();
  if (!loaded || !page.sections) {
    return (
      <div className="loader-wrap">
        <div className="loader" />
      </div>
    );
  }
  return (
    <div className="App">
      <TopBar />
      <PageRenderer sections={page.sections} />
    </div>
  );
}
